import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '../views/Login.vue'
import Home from '../views/Home.vue'

// 路由分模块
import deviceRouter from './modules/device' // 设备
import orderRouter from './modules/order' // 订单
import refundRouter from './modules/refund' // 订单
import dataRouter from './modules/data' // 数据统计
// import imagesRouter from './modules/images' // 图片查询
import liveRouter from './modules/live' // 画面直播
import userRouter from './modules/user' // 用户

const changePush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return changePush.call(this, location).catch((err) => err)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/device'
  },
  deviceRouter,
  orderRouter,
  refundRouter,
  dataRouter,
  // imagesRouter,
  liveRouter,
  userRouter,
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/dataSearch',
    name: 'dataSearch',
    component: () => import('@/views/dataSearch/dataSearch.vue')
  },
  {
    path: '/picture',
    name: 'picture',
    component: () => import('@/views/picture/picture.vue')
  },
]

const router = new VueRouter({
  routes,
  mode: 'hash'
})

export default router
